<app-instance-info-section></app-instance-info-section>
<div class="row">
    <div class="col-md-3">
        <div class="lie-format-list gutter-b card-stretch">
            <div class="idms_view_title">
                <h3>Line Number Format</h3>
                <button class="btn primary-ebtn" (click)="addNewLineNumberFormat()"><i class="fa fa-plus"></i></button>
            </div>
            <div class="idms_view_details" *ngIf="defaultLineNumberFormatList">
                <ul>
                    <li *ngFor="let lineFormat of defaultLineNumberFormatList; let i = index" class="position-relative"
                        [ngClass]="
                            selectedLineFormat !== null &&
                            (selectedLineFormat?.lineNumberFormatId
                                ? selectedLineFormat?.lineNumberFormatId == lineFormat?.lineNumberFormatId
                                : selectedLineFormat.name == lineFormat.name)
                                ? 'active'
                                : ''
                        ">
                        <div class="linenumber-name" (click)="loadNumberFormatDetails(lineFormat, i)">
                            {{ lineFormat?.name }}
                            <span *ngIf="formGroupArray[i] && !formGroupArray[i].valid" class="text-danger">
                                <strong>✘</strong>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="lie-format-list gutter-b card-stretch">
            <div class="idms_view_title">
                <h3>Joint ID Format</h3>
                <button class="btn primary-ebtn" *ngIf="false" (click)="addNewLineNumberFormat()"><i
                        class="fa fa-plus"></i></button>
            </div>
            <div class="idms_view_details" *ngIf="jointFormatList">
                <ul>
                    <li *ngFor="let joint of jointFormatList; let i = index"
                        [ngClass]="isJointFormatSelect ? 'active' : ''" class="position-relative"
                        (click)="loadJointID()">
                        <!-- [ngClass]="selectedLineFormat !== null && ((selectedLineFormat?.lineNumberFormatId)?(selectedLineFormat?.lineNumberFormatId == lineFormat?.lineNumberFormatId): (selectedLineFormat.name == lineFormat.name)) ?'active':''"
                        >  -->
                        <div class="linenumber-name">
                            {{ joint }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!--This is Line Number Format COnfiguration Screen @START-->
    <div class="col-md-9" *ngIf="selectedLineFormat">
        <div class="card card-custom lie-format-list gutter-b card-stretch" *ngIf="selectedLineFormat">
            <div class="idms_view_title">
                <h3>Configure Line Number Format<a *ngIf="!selectedLineFormat?.lineNumberFormatId" class="close-icon"
                        [matTooltip]="Cancel" href="javascript:void()" ngbAutofocus (click)="cancelClick()">
                        <i class="flaticon2-cross"></i>
                    </a></h3>
            </div>

            <div class="hierarchy_view_section">
                <div class="row" style="margin: 0 auto; width: 100%; display: flex">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="main-wrap-container">
                                <app-line-number-format-details (tabIndexChanged)="handleTabChange($event)"
                                    (allowFreeForm)="allowFreeFormHandler($event)"
                                    (formetNameChanged)="formetNameChangedHander($event)"
                                    [nameList]="lineNumberFormatNameList" [selectedTabNo]="activeIndex"
                                    [linenumberFormat]="selectedLineFormat"
                                    [linerNumberFormatFormGroup]="getFormGroup()"
                                    [defaultLineNumberFormatSectionTypes]="defaultLineNumberFormatStatusType"
                                    [currentInstanceId]="currentInstanceId">
                                </app-line-number-format-details>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-9" *ngIf="!isJointFormatSelect && !selectedLineFormat">
        <div class="card card-custom lie-format-list gutter-b card-stretch">
            <div class="d-flex justify-content-center align-items-center h-100 text-danger">
                <h4>Please Select number format/ joint id to configure!</h4>
            </div>
        </div>
    </div>
    <!--This is Line Number Format COnfiguration Screen @END-->

    <!--JOINT ID CONFIGURATION SCREEN @START-->
    <div class="col-md-9" *ngIf="isJointFormatSelect">
        <div class="card card-custom custom-border gutter-b card-stretch">
            <div class="idms_view_title">
                <h3>Configure Joint ID Format</h3>
            </div>
            <div class="row" style="margin: 0 auto; width: 100%; display: flex">
                <div class="col-md-12">
                    <div class="hierarchy_view_section">
                        <div class="row">
                            <div class="main-wrap-container">
                                <div class="col-md-12 d-flex justify-content-start">
                                    <div
                                        style="border:1px solid red ; border-radius: 5px; display: flex; align-items: center; margin-left: 10px;padding: 5px; color:red">
                                        <i class="mdi mdi-alert-outline icon-red" [matTooltip]=""></i>
                                        <p style="margin: 0 0 0 5px;">
                                            Warning: 'Joint ID Format' can only be set during Instance creation. Contact
                                            your
                                            system administrator to modify it later.
                                        </p>
                                    </div>

                                </div>
                                <app-join-id-format-details [jointIDForm]="jointIDForm"
                                    [jointIDSetting]="jointIDSettings"
                                    [JointIdDropDown]="JointIdDropDown"></app-join-id-format-details>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>